import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DataBagService } from 'src/app/common/data-bag.service';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class TourismEventsService {
	organizations: Subject<any[]> = new Subject();
	organization: Subject<any> = new Subject();
	defaultOrganization = environment.production ? 5 : 25;

	constructor(private readonly api: DataBagService) {}

	loadOrganizations(callback) {
		this.api.get('/organization/?limit=99999', ({ results }) => {
			if (results) this.organizations.next(results);
			callback();
		});
	}

	getOrganization() {
		this.api.get(`/organization/${this.defaultOrganization}/`, (result) => {
			if (result) this.organization.next(result);
		});
	}
}
